import { render, staticRenderFns } from "./apartment-project-status.vue?vue&type=template&id=56dcbbe6&scoped=true&"
import script from "./apartment-project-status.ts?vue&type=script&lang=ts&"
export * from "./apartment-project-status.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-project-status.scss?vue&type=style&index=0&id=56dcbbe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dcbbe6",
  null
  
)

export default component.exports